import apiClient from './client';

/**
 * The fields ManualImportDialog needs from GET /tenants/current. `display_currency`
 * is the tenant's own EXPLICIT setting (schemas/tenant.py); `effective_display_currency`
 * is a derived fallback and must not be used here, because a manual import row only
 * ever carries a currency when the tenant set one explicitly (manual_import.py:528).
 */
export interface CurrentTenant {
  display_currency: string | null;
  // The derived fallback (tenant setting, else billing country, else USD).
  // AuthContext uses this one to set the app-wide display currency on
  // sign-in; ManualImportDialog must keep using display_currency above.
  effective_display_currency?: string | null;
}

export const getCurrentTenant = async (): Promise<CurrentTenant> => {
  const response = await apiClient.get('/tenants/current');
  return response.data;
};
